import * as XLSX from 'xlsx';
import { DayAgoPipe } from '../shared/day-ago.pipe';
import { Component, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { UserDataService } from '../features/user-data.service';

@Component({
  selector: 'app-patent-list',
  templateUrl: './patent-list.component.html',
  styleUrls: ['./patent-list.component.css']
})
export class PatentListComponent implements OnInit, OnChanges {
  status="";
  users:any;
  userskeys:any;
  detail=new Subject();//the detail of a key data will be send to patent detail
  usersForRender:any; //cut the inventors part render purposes
  error="";
  token="";
  record:string="";
  userSubs!:Subscription;
  userWithToken:any;
  searchText:any;
  today=Date.now();
  oneDay = 24*60*60*1000;
  paintRows:any;
  lastStatus:any;
  visible=false;
  users1:any;

  counter=0;
  counterResult=0;

  countryName="";
  searchPatStatus="";
  searchInventorName="";
  searchAttorneyName="";
  searchCompanyName="";
  searchInvRight="";
  applicationNo="";
  publicationNo="";
  documentNo="";
  result:any;
  recData:any;
  patLastStatusStartDate ="1900-01-01";
patLastStatusEndDate = "2100-12-31";
invDecStartDate="1900-01-01";
invDecEndDate = "2100-12-31";
  visibleSearch=false;
  switch=false;
  users1Reverse:any;

  visDoc=true;
  visInvName=true;
  visInvDate=true;
  visStatus=true;
  visAttorney=true;
  visTRStatus=true;
  visTRReg=true;
  visTRApp=true;
  visLastUpdate=true;
  visOwner=true;
  visInventor=true;
  visPatentRec=true;
  constructor(private userData:UserDataService, private user:AuthService, private route:Router) {

   }

   ngOnInit(): void {
    this.token=this.user.token;
    this.userData.fetchUsers(this.token).subscribe(
      (res: any) => {
       this.visible=true;
       if (!res) {
         this.record="Buluş Bulunamadı";
         alert("Buluş Bulunamadı. Sisteme ilk kez giriş yapıyorsanız buluş eklemeden önce veri merkezi sekmesi üzerinden sırası ile Şirket Kaydı, Buluşçu Kaydı ve Patent Vekili kaydını girmeniz gerekmektedir.")
       } else {

       //console.log(res);
       this.userWithToken=res;
       this.users = Object.keys(res).map((key) =>
       {   return res[key] });
       this.users1 = Object.keys(res).map((key) =>
       {   res[key][0].status=res[key][0].status.slice(-1)[0];

          return res[key] });





       this.userskeys= Object.keys(res).map((key) =>
       { return (key) });

       this.paintRows=Object.keys(res).map((key) =>
       { return res[key][0].status.date });

       this.result=this.users;
        console.log(this.users);

       this.record=""
     }},err=>this.error=(err.statusText)
   );
    }
    ngOnChanges(): void {
      this.token=this.user.token;
      this.userData.fetchUsers(this.token).subscribe(
        (res: any) => {
         this.visible=true;
         if (!res) {
           this.record="Buluş Bulunamadı"
         } else {

         //console.log(res);
         this.userWithToken=res;
         this.users = Object.keys(res).map((key) =>
         {   return res[key] });
         this.recData = Object.keys(res).map((key) =>
       {   return res[key] });
         this.users1 = Object.keys(res).map((key) =>
         {   res[key][0].status=res[key][0].status.slice(-1)[0];
            return res[key] });

         this.userskeys= Object.keys(res).map((key) =>
         { return (key) });

         this.paintRows=Object.keys(res).map((key) =>
         { return res[key][0].status.date });


         this.record=""
       }},err=>this.error=(err.statusText)
     );
      }


    searchSwitch() {this.switch=!this.switch;
     this.countryName="";
    this.searchText=null}
    checkVisDoc(){return this.visDoc}
    checkVisInvName(){return this.visInvName}
    checkVisInvDate() {return this.visInvDate}
    checkVisStatus() {return this.visStatus}

    checkVisAttorney(){return this.visAttorney}
    checkVisTRStatus(){return this.visTRStatus}
    checkVisTRReg(){return this.visTRReg}
    checkVisTRApp(){return this.visTRApp}
    checkVisLastUpdate(){return this.visLastUpdate}
    checkvisOwner(){return this.visOwner}
    checkvisInventor(){return this.visInventor}
    checkvisPatentRec(){return this.visPatentRec}


    searchCriterias() {
      this.visibleSearch=true;
      this.counter=0;
      this.counterResult=0;
      console.log(this.result);
      this.inventionDateSearch();

      this.users1=[];
      let clone=  [...this.users];
  this.recData=clone;
      console.log(this.users);
      console.log(this.recData);
      console.log(this.result);



             /* if (!this.countryName && !this.registrationYear && !this.applicationYear) {

                for (const [i,item] of this.users.entries())  {
                              this.counter++;



                   }
                   this.counterResult=this.counter;
                   this.users1=this.users

                }*/


    }
    inventionDateSearch(){
      console.log (this.result.length);
      for (let i=0; i<this.result.length; i++){
        console.log(this.result[i][0].inventionDate)
          if (this.result[i][0].inventionDate<this.invDecStartDate || this.result[i][0].inventionDate>this.invDecEndDate) {
            console.log("doğru");
            (this.result.splice(i, 1));
            i--;
          }
          else {console.log("yanlış");}

      }
     }
    removeInvention(i:number) {
      //console.log(this.userskeys[i]);
      /* this.http.delete('https://sisecam-a8421-default-rtdb.firebaseio.com/patents/'+ this.users.key[i] +'.json?auth='+this.token).subscribe(res=>{console.log(res)},err=> this.error=(err.statusText));*/
      this.userData.removeInvention(this.userskeys[i]);
      this.redirectTo('patentList');
    }
    inventionDetails(i:number, docNo:string){

      this.route.navigate(['patentList/',docNo]);
      //console.log(this.detail);
      this.userData.getKey(this.userskeys[i]);

     }
    redirectTo(uri:string){
      this.route.navigateByUrl('/', {skipLocationChange: true}).then(()=>
      this.route.navigate([uri]));
   }
   fileName= 'BuluşKayıtları.xlsx';

   exportexcel(): void
 {
   /* pass here the table id */
   let element = document.getElementById('excel-table');
   const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

   /* generate workbook and add the worksheet */
   const wb: XLSX.WorkBook = XLSX.utils.book_new();
   XLSX.utils.book_append_sheet(wb, ws, 'Buluş Bilgileri');

   /* save to file */
   XLSX.writeFile(wb, this.fileName);

 }
}
